(() => {
  if (window.__testimonialsMasonryContentToggleInitialized) return;
  window.__testimonialsMasonryContentToggleInitialized = true;

  const toggleContent = (content) => {
    const initialTop = content.getBoundingClientRect().top;
    const isExpanded = content.classList.toggle('is-expanded');
    content.setAttribute('aria-expanded', String(isExpanded));
    content.setAttribute('aria-label', isExpanded ? 'Full review. Click to collapse.' : 'Show full review');

    const section = content.closest('.testimonials-masonry');
    requestAnimationFrame(() => {
      const masonry = section?.querySelector('masonry-layout');
      const slider = section?.querySelector('testimonials-masonry-slider');

      slider?.alignProductRows?.();
      slider?.sliderInstance?.slider?.update();
      masonry?.calculatePositioning();

      requestAnimationFrame(() => {
        const offset = content.getBoundingClientRect().top - initialTop;
        if (offset) window.scrollBy(0, offset);
      });
    });
  };

  document.addEventListener('click', (event) => {
    const content = event.target.closest('[data-testimonial-expandable]');
    if (!content || event.target.closest('a, button')) return;
    toggleContent(content);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const content = event.target.closest('[data-testimonial-expandable]');
    if (!content) return;

    event.preventDefault();
    toggleContent(content);
  });
})();
